import components from "./components.json";
import views from "./views.json";

export const nl = {
  components,
  views,
};
